import React from "react";

const Popup = ({ isOpen, closePopup, popupImage }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <span className="close-btn" onClick={closePopup}>
          &times;
        </span>
        <div className="modal-content-main">
          <img src={popupImage} alt="Popup" className="popup-img" />
        </div>
      </div>
    </div>
  );
};

export default Popup;
